import React from "react";
import {
  Box,
  Container,
  Heading,
  Text,
  SimpleGrid,
  Card,
  CardBody,
  CardHeader,
  Button,
  useColorMode,
  VStack,
  HStack,
  Image,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Main = () => {
  const { colorMode } = useColorMode();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const services = [
    {
      title: t("main.services.sanity.title"),
      description: t("main.services.sanity.description"),
      icon: "/sanity_logo.png",
      color: "blue",
      path: "/sanity",
      externalLink: "https://sanity.keymakr.com",
    },
    {
      title: t("main.services.clone.title"),
      description: t("main.services.clone.description"),
      icon: "/cloner_logo.png",
      color: "green",
      path: "/clone",
      externalLink: "https://project-cloner.keymakr.com",
    },
    {
      title: t("main.services.dedup.title"),
      description: t("main.services.dedup.description"),
      icon: "/dedup_logo.png",
      color: "yellow",
      path: "/dedup",
      externalLink: "https://dedup.keymakr.com",
    },
    {
      title: t("main.services.slack.title"),
      description: t("main.services.slack.description"),
      icon: "/slack_logo.png",
      color: "red",
      path: "/slack",
      externalLink: "https://slack.notification.keymakr.com/",
    },
    {
      title: t("main.services.export.title"),
      description: t("main.services.export.description"),
      icon: "/export_logo.png",
      color: "purple",
      path: "/export",
      externalLink: "https://export-converters.keymakr.com/",
    },
    {
      title: t("main.services.voxel51.title"),
      description: t("main.services.voxel51.description"),
      icon: "/fiftyone_logo.png",
      color: "orange",
      path: "/voxel51",
      externalLink: "https://voxel51.keymakr.com/",
    },
  ];

  return (
    <Container maxW="container.xl" py={8}>
      <VStack spacing={8} align="stretch">
        <Box textAlign="center" py={8}>
          <Heading
            size="2xl"
            mb={4}
            color={colorMode === "dark" ? "white" : "gray.800"}
          >
            {t("main.welcome")}
          </Heading>
          <Text
            fontSize="xl"
            color={colorMode === "dark" ? "gray.300" : "gray.600"}
          >
            {t("main.chooseService")}
          </Text>
        </Box>

        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={8}>
          {services.map((service, index) => (
            <Card
              key={index}
              bg={colorMode === "dark" ? "gray.700" : "white"}
              borderWidth="1px"
              borderColor={colorMode === "dark" ? "gray.600" : "gray.200"}
              _hover={{
                transform: "translateY(-4px)",
                boxShadow: "lg",
                transition: "all 0.2s",
              }}
            >
              <CardHeader>
                <HStack spacing={4}>
                  <Image
                    src={service.icon}
                    alt={service.title}
                    height="80px"
                    width="auto"
                    objectFit="contain"
                  />
                  <Heading size="md">{service.title}</Heading>
                </HStack>
              </CardHeader>
              <CardBody>
                <VStack spacing={4} align="stretch">
                  <Text
                    color={colorMode === "dark" ? "gray.300" : "gray.600"}
                    fontSize="md"
                  >
                    {service.description}
                  </Text>
                  <Button
                    colorScheme={service.color}
                    onClick={() => {
                      if (service.externalLink) {
                        window.open(
                          service.externalLink,
                          "_blank",
                          "noopener,noreferrer"
                        );
                      } else {
                        navigate(service.path);
                      }
                    }}
                    size="lg"
                    width="full"
                  >
                    {t("main.getStarted")}
                  </Button>
                </VStack>
              </CardBody>
            </Card>
          ))}
        </SimpleGrid>
      </VStack>
    </Container>
  );
};

export default Main;
